/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

/**
 * Possible values for the grid page sizes. This is in
 * use when pagination is enabled
 */
export const PAGE_SIZES = [20, 50, 100];
/**
 * Base64 encoded SVG for the active filter icon
 * You can decode it at https://www.base64decode.org/
 * or view the raw SVG at https://www.svgrepo.com/svg/331790
 * Note: The fill color #0097AF has been set to currentColor so it inherits
 */
export const ACTIVE_FILTER_ICON = 'PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHJ4PSIzIiBmaWxsPSIjMDA5N0FGIi8+CiAgPHBhdGggZD0iTTMuODUxNTIgMy4xNjY2N0gxMi4xNDg2QzEyLjU2NzIgMy4xNjY2NyAxMi44MDA1IDMuNjUwNDEgMTIuNTM5OCAzLjk3OEw5LjY5Mjk3IDcuNTU1NjlDOS40ODE3MyA3LjgyMTE2IDkuMzY2NzIgOC4xNTA0MSA5LjM2NjcyIDguNDg5N1YxMS41OTVDOS4zNjY3MiAxMS43NDUzIDkuMjk5MDYgMTEuODg3NyA5LjE4MjQ5IDExLjk4MjZMNy40NDkxNiAxMy4zOTQ1QzcuMTIyNTEgMTMuNjYwNiA2LjYzMzM5IDEzLjQyODEgNi42MzMzOSAxMy4wMDY4VjguNDg5N0M2LjYzMzM5IDguMTUwNDEgNi41MTgzOCA3LjgyMTE2IDYuMzA3MTMgNy41NTU2OUwzLjQ2MDI3IDMuOTc4QzMuMTk5NiAzLjY1MDQxIDMuNDMyODcgMy4xNjY2NyAzLjg1MTUyIDMuMTY2Njd6IiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSIjMDA5N0FGIi8+Cjwvc3ZnPg==';
